import { SalesMetricBasis } from '@plato/app-meta/sales-metric';

import { generateSearchParamsForExplorer } from '../features/explorer/hooks/use-explorer-query-params.ts';
import type { QuoteOrderQueryFilters } from '../features/quote-order-list/hooks/use-quote-order-list-filters.tsx';
import {
    generateSearchParamsForQuotesOrders,
    openOrdersFilter,
    openQuotesFilter,
} from '../features/quote-order-list/hooks/use-quote-order-list-filters.tsx';

import {
    ExplorerSortBy,
    ExplorerSortOrder,
    ExplorerTopLevelEntity,
    TargetUnit,
    VisibilityWindow,
} from '../server/utils/explorer-utils.ts';

export function generateSearchParamsForOpenOrders(params: Partial<QuoteOrderQueryFilters>) {
    return generateSearchParamsForQuotesOrders({ ...openOrdersFilter, ...params });
}

export function generateSearchParamsForOpenQuotes() {
    return generateSearchParamsForQuotesOrders(openQuotesFilter);
}

export function generateSearchParamsForCustomerInsightsNormalisedCategory(
    categoryId: string,
    categoryName: string,
) {
    return generateSearchParamsForExplorer({
        tab: ExplorerTopLevelEntity.NORMALISED_CATEGORY,
        window: VisibilityWindow.TTM,
        normalisedCategory: [categoryId],
        searchStringNormalisedCategory: categoryName,
        targetUnit: TargetUnit.REVENUE,
        billing: SalesMetricBasis.BILLED,
        sorting: {
            field: ExplorerSortBy.REVENUE_CURRENT,
            direction: ExplorerSortOrder.DESC,
        },
        yearPeriods: 2,
    });
}
